<template>
    <li
        class="relative px-6 py-3 flex"
        :class="{'bg-gray-200': active}"
    >
<!--        <span v-if="active"
              class="absolute inset-y-0 left-0 w-1 bg-purple-600 rounded-tr-lg rounded-br-lg"
              aria-hidden="true"
        ></span>-->
        <inertia-link
            class="inline-flex items-center w-full text-sm font-semibold transition-colors duration-150 hover:text-gray-800 dark:hover:text-gray-200"
            :class="{'text-gray-800 dark:text-gray-100': active}"
            :href="href"
        >
            <div class="w-5 h-5"><slot name="icon"></slot></div>
            <span class="ml-4 text-lg leading-5 font-semibold"><slot name="title"></slot></span>
        </inertia-link>
    </li>
</template>

<script>
export default {
    name: "SidebarItem",
    props: {
        active: Boolean,
        href: String,
    }
}
</script>

<style scoped>

</style>
